var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tip-box',{attrs:{"text":_vm.$t('module_external_action_no_tiktok_hint'),"width":"100%"}})}
var staticRenderFns = []

export { render, staticRenderFns }